import { useState } from 'react';
import PropTypes from 'prop-types';

function IconRefresh({
  className,
  width,
  height,
  id,
  color,
  hoverColor,
  viewBox,
}) {
  const [mainColor, setMainColor] = useState(color);
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox={viewBox}
      onMouseEnter={() => setMainColor(hoverColor)}
      onMouseLeave={() => setMainColor(color)}
    >
      <defs>
        <path
          id="icon-refresh"
          d="M20.9246862,10.7994266 C20.9246862,10.8744315 20.8493724,10.8744315 20.8493724,10.9494365 C20.8493724,10.9494365 20.8493724,11.0244414 20.7740586,11.0244414 C20.7740586,11.0244414 20.7740586,11.0244414 20.7740586,11.0244414 C20.6987448,11.0994464 20.623431,11.1744513 20.5481172,11.1744513 C20.5481172,11.1744513 20.5481172,11.1744513 20.5481172,11.1744513 C20.4728033,11.2494562 20.3221757,11.2494562 20.2468619,11.2494562 L15.7280335,11.2494562 C15.2761506,11.2494562 14.9748954,10.9494365 14.9748954,10.4994068 C14.9748954,10.0493772 15.2761506,9.74935738 15.7280335,9.74935738 L18.3640167,9.74935738 L16.2552301,7.79922886 C15.5774059,7.12418437 14.8242678,6.67415471 13.9958159,6.37413494 C12.4895397,5.84910033 10.832636,5.92410528 9.40167364,6.59914977 C7.89539749,7.27419425 6.84100418,8.47427335 6.31380753,9.97437221 C6.16317992,10.3493969 5.71129707,10.5744118 5.33472803,10.4244019 C4.958159,10.3493969 4.73221757,9.89936727 4.88284519,9.52434255 C5.56066946,7.57421403 6.91631799,6.07411516 8.72384937,5.24906079 C10.5313808,4.34900147 12.5648536,4.27399653 14.4476987,4.94904101 C15.5020921,5.32406573 16.4811715,5.92410528 17.2343096,6.74915965 L19.4937238,8.77429312 L19.4937238,5.99911022 C19.4937238,5.54908056 19.7949791,5.24906079 20.2468619,5.24906079 C20.6987448,5.24906079 21,5.54908056 21,5.99911022 L21,10.4994068 C21,10.4994068 21,10.5744118 21,10.5744118 C21,10.6494167 21,10.7244216 20.9246862,10.7994266 Z M18.5899582,13.5746095 C18.2133891,13.4245996 17.7615063,13.6496144 17.6108787,14.0246391 C17.3096234,14.8496935 16.8577406,15.6747479 16.1799163,16.2747874 C15.125523,17.3998616 13.5439331,17.9999011 11.9623431,17.9999011 L11.9623431,17.9999011 C10.3807531,17.9999011 8.87447699,17.3998616 7.66945607,16.1997825 L5.56066946,14.249654 L8.19665272,14.249654 C8.64853556,14.249654 8.94979079,13.9496342 8.94979079,13.4996045 C8.94979079,13.0495749 8.64853556,12.7495551 8.19665272,12.7495551 L3.67782427,12.7495551 C3.67782427,12.7495551 3.67782427,12.7495551 3.67782427,12.7495551 C3.60251046,12.7495551 3.60251046,12.7495551 3.52719665,12.7495551 C3.45188285,12.7495551 3.45188285,12.7495551 3.37656904,12.7495551 C3.37656904,12.7495551 3.30125523,12.7495551 3.30125523,12.8245601 C3.22594142,12.8245601 3.15062762,12.899565 3.15062762,12.9745699 C3.15062762,12.9745699 3.15062762,12.9745699 3.15062762,12.9745699 C3.15062762,12.9745699 3.15062762,13.0495749 3.07531381,13.0495749 C3.07531381,13.1245798 3,13.1245798 3,13.1995848 C3,13.2745897 3,13.2745897 3,13.3495947 C3,13.3495947 3,13.4245996 3,13.4245996 L3,17.9248962 C3,18.3749259 3.30125523,18.6749456 3.75313808,18.6749456 C4.20502092,18.6749456 4.50627615,18.3749259 4.50627615,17.9248962 L4.50627615,15.1497133 L6.69037657,17.2498517 C8.0460251,18.7499506 9.92887029,19.5 11.9623431,19.5 C11.9623431,19.5 11.9623431,19.5 11.9623431,19.5 C13.9958159,19.5 15.8786611,18.7499506 17.3096234,17.3248566 C18.0627615,16.5748072 18.7405858,15.599743 19.1171548,14.5496737 C19.1924686,14.0996441 18.9665272,13.6496144 18.5899582,13.5746095 Z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <rect width="24" height="24" />
        <mask id={id} fill="#FFF">
          <use xlinkHref="#icon-refresh" />
        </mask>
        <g fill={mainColor} mask={`url(#${id})`}>
          <rect width="24" height="24" />
        </g>
      </g>
    </svg>
  );
}

IconRefresh.defaultProps = {
  className: undefined,
  width: 24,
  height: 24,
  color: '#fff',
  hoverColor: '#fff',
  viewBox: '0,0,24,24',
};

IconRefresh.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  id: PropTypes.string.isRequired,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  viewBox: PropTypes.string,
};

export default IconRefresh;
